import axios from "vue-app/utils/axios";
import {
  DTOTrackerLeaving,
  DTOTrackerLeavingAnswerRequest,
  DTOTrackerLeavingDataScienceResponse,
  DTOTrackerLeavingQuestion,
} from "vue-app/api/dto";
import moment from "moment-timezone";

export const getStatistics = async () => {
  const { data } = await axios.get<DTOTrackerLeavingDataScienceResponse>("/tracker/leaving/statistics");

  return data;
};

export const getQuestions = async () => {
  const { data } = await axios.get<DTOTrackerLeavingQuestion[]>("/tracker-leaving/questions");
  return data;
};

export const postTrackerLeaving = async (answers: DTOTrackerLeavingAnswerRequest[]) => {
  const { data } = await axios.post("/tracker-leaving", {
    ...answers,
  });

  return data;
};

export const putWithdrawTracker = async (id: number) => {
  const { data } = await axios.put(`/tracker-leaving/${id}/withdraw`);
  return data;
};

export const getTrackerLeaving = async () => {
  const { data } = await axios.get<DTOTrackerLeaving>("/tracker-leaving/open");
  if ("scheduledRemovalDate" in data) {
    return {
      ...data,
      scheduledRemovalDate: data.scheduledRemovalDate
        ? moment(data.scheduledRemovalDate).format("Do MMM")
        : (data.scheduledRemovalDate as null),
    };
  }

  return null;
};
